import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { api, apiBlob } from './hrApi';
import { useAuth } from './hrAuth';
import EmployeeSelect from './hrComponents/EmployeeSelect';

export default function History() {
  const { has, user } = useAuth();
  const [searchParams] = useSearchParams();
  const [emp, setEmp] = useState(searchParams.get('emp') || '');
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api(`/history?limit=200${emp ? '&emp='+emp : ''}`)
      .then(d => { setItems(d.items); setTotal(d.total); })
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [emp]);

  const openPhoto = async (id) => {
    try { window.open(await apiBlob(`/history_photo/${id}`), '_blank'); }
    catch { alert('Photo not available'); }
  };

  return (
    <section className="page on">
      <h2 className="pagetitle display">History</h2>
      <div className="pagesub">All face check-in attempts — successes and failures, with captured photos.</div>
      {(user.role === 'admin' || has('team')) && <EmployeeSelect value={emp} onChange={setEmp} />}
      {loading ? <div className="loading">Loading…</div> :
       !items.length ? <div className="loading">No attempts yet.</div> : (
        <>
          <div className="note" style={{marginBottom:8}}>Showing {items.length} of {total}</div>
          <table className="t">
            <thead><tr><th>TIME</th><th>SOURCE</th><th>ACTION</th><th>RESULT</th><th>CONF.</th><th>ATTENDANCE</th><th>LOCATION</th><th>PHOTO</th></tr></thead>
            <tbody>
              {items.map(i => (
                <tr key={i.id}>
                  <td>{i.time}</td><td>{i.source}</td>
                  <td>{i.action==='checkin'?'Check-in':'Check-out'}</td>
                  <td><span className={`pill ${i.result==='Success'?'ok':'bad'}`}>{i.result}</span></td>
                  <td>{i.confidence?i.confidence+'%':'—'}</td>
                  <td><span className={`pill ${i.attendance?'ok':'mut'}`}>{i.attendance?'Recorded':'—'}</span></td>
                  <td>{i.lat?<a href={`https://maps.google.com/?q=${i.lat},${i.lng}`} target="_blank" rel="noreferrer">map</a>:'—'}</td>
                  <td>{i.photo?<button className="tinybtn" onClick={() => openPhoto(i.id)}>View</button>:'—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </section>
  );
}
